export default __webpack_public_path__ + "static/media/6.1165eba1.jpg";